import styled from "styled-components";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

export const StyledRadioGroup = styled(RadioGroup)`
  width: 19px;
  height: 19px;
  border-radius: 24px;
  background-color: #ffffff;

  @media only screen and (max-width: 959.95px) and (orientation: portrait) {
    display: block !important;
  }

  label {
      margin-top: -12px;
  }
`;

export const StyledRadio = styled(Radio)`
  display: inline-block !important;
`;
